export default "__VITE_ASSET__CYUTviQh__"